<div [class.closing]='closing$ | async' class='bottom-sheet-window'>
      <div (click)="openChat()">{{chatPopupQuery.label$ | async}}</div>
      <button (click)='close()' class='close-button'>
        <i class="fa fa-close"></i>
      </button>
</div>
